import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { Customer } from '../redux/models/customer';
import { customerConfig } from '@uxdf/direct-shared-lib';
import { Store, select } from '@ngrx/store';
import { skipWhile, map, take } from 'rxjs/operators';

@Injectable()
export class CustomerConfigGuard implements CanActivate {
  constructor(private readonly store: Store<any>) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(select(customerConfig)).pipe(
      skipWhile(
        (customerConfigState: { customerConfig: Customer }) => !customerConfigState.customerConfig.default_store_code
      ),
      take(1),
      map(() => true)
    );
  }
}
